export default "__VITE_ASSET__Bi4CWC7B__"